import { useEffect, useRef, useState } from 'react';
import styles from './ProgressBarWithBubble.module.css';

interface IProgressBar {
  totalSteps: number;
  currentStep: number;
}

const ProgressBarWithBubble = ({ totalSteps, currentStep }: IProgressBar) => {
  // Don't divide by zero
  const fudgedTotalSteps = totalSteps || 1;
  const progress = Math.min((currentStep / fudgedTotalSteps) * 100, 100);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const bubbleRef = useRef<HTMLDivElement>(null);
  const [bubbleLeft, setBubbleLeft] = useState(0);

  useEffect(() => {
    const wrapper = wrapperRef.current;
    const bubble = bubbleRef.current;

    if (wrapper && bubble) {
      const wrapperWidth = wrapper.offsetWidth;
      const bubbleWidth = bubble.offsetWidth;

      const rawLeft = (progress / 100) * wrapperWidth;
      const clampedLeft = Math.min(
        Math.max(rawLeft, bubbleWidth / 2),
        wrapperWidth - bubbleWidth / 2
      );

      setBubbleLeft(clampedLeft);
    }
  }, [progress]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.progressWrapper} ref={wrapperRef}>
        <div
          className={styles.bubbleBox}
          ref={bubbleRef}
          style={{ left: `${bubbleLeft}px` }}
        >
          {Math.round(progress)}% SOLD
          <div className={styles.bubbleTail}></div>
        </div>

        <div className={styles.progressBase}></div>
        <div
          className={styles.progressBar}
          style={{ width: `${progress}%` }}
        ></div>
      </div>

      <div className={styles.labelRow}>
        <span>0</span>
        <span>{totalSteps}</span>
      </div>
    </div>
  );
};

export default ProgressBarWithBubble;